import React, { useState } from "react";
import "./header.css";
import ME from "../../assets/me.png";
import MECover from "../../assets/me-cover.png";
import HeaderSocials from "./HeaderSocials";
import CTA from "./CTA";

const Header = () => {
  const [imgSrc, setImgSrc] = useState(ME);

  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h3>Mohammadreza Sharifi</h3>
        <h5 className="text-light">Front-End Developer</h5>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={imgSrc} alt="me" />
        </div>

        <a href="#contact" className="scroll__down">
          --- Follow Me ---
        </a>
      </div>
    </header>
  );
};

export default Header;
